import store from '../store/index';

function updateStyle(el, binding) {
    if (store.getters['features/getFeatures'].includes(binding.value)) {
        el.style.display = el.__disp_prev__;
    } else {
        el.style.display = 'none';
    }
}

const RequireFeature = {
    bind: function (el, binding) {
        el.__disp_prev__ = el.style.display;
        updateStyle(el, binding);
        el.__features_unwatch__ = store.watch(state => state.features.features, () => {
            updateStyle(el, binding);
        });
    },

    unbind(el) {
        el.__features_unwatch__ && el.__features_unwatch__()
    }

};

export default RequireFeature;
